import { render, staticRenderFns } from "./pa-sunburst.vue?vue&type=template&id=40c7a04c&scoped=true"
import script from "./pa-sunburst.vue?vue&type=script&lang=js"
export * from "./pa-sunburst.vue?vue&type=script&lang=js"
import style0 from "./pa-sunburst.vue?vue&type=style&index=0&id=40c7a04c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c7a04c",
  null
  
)

export default component.exports